export const routeVariants = {
  bottom: { y: '100%', opacity: 0, transition: { duration: 0.5, ease: 'easeInOut' } },
  enter: { y: 0, opacity: 1, transition: { duration: 0.5, ease: 'easeInOut' } },
  top: { y: '-100%', opacity: 0, transition: { duration: 0.5, ease: 'easeInOut' } },
};
